import Button from "@components/Button";
import Link from "@components/Link";
import { useTranslationContext } from "@providers/TranslationProvider";
import cx from "classnames";
import HorizontalItem from "./HorizontalItem";
import styles from "./Stories2Inspire.module.scss";
import VerticalItem from "./VerticalItem";
import { usePageContext } from "@providers/PageProvider";
import helper from "@utils/helper";
import StoryArticleService from "@services/StoryArticleService";
import map from "lodash/map";
import get from "lodash/get";
import usePromise from "@hooks/usePromise";

const View = () => {
  const { i18n } = useTranslationContext();
  const { pageData, hotel } = usePageContext();
  const [articles] = usePromise(async () => {
    const resArticle = await StoryArticleService.find({
      populate: ["thumbnail", "category"],
      page: 1,
      pageSize: 4,
      locale: i18n.language,
      filters: {
        hotels: {
          slug: {
            $eq: hotel,
          },
        },
      },
    });
    return get(resArticle, "data", []);
  });

  const POSTS = map(articles, helper.formatArticleItem);
  const stories = helper.formatStories(pageData);
  const readMoreButton = get(stories, "readMoreButton");
  return (
    <section data-scroll-section className={cx("", styles.section)}>
      <div className={cx("inner-large", styles.boxTitle)}>
        <div className={cx(styles.title)}>{get(stories, "title")}</div>
        <Link
          href={get(readMoreButton, "href")}
          className={cx(styles.viewAllStories)}
        >
          <Button
            type="icon"
            suffix="shape-arrow"
            label={
              <div className={cx(styles.text)}>
                {get(readMoreButton, "label")}
              </div>
            }
          />
        </Link>
      </div>
      {!!POSTS.length && (
        <div className={cx("inner-large", styles.box)}>
          <div className={styles.colL}>
            <VerticalItem {...POSTS[0]} className={cx(styles.vertical)} />
            <HorizontalItem {...POSTS[2]} className={cx(styles.horizontal)} />
          </div>
          <div className={styles.colR}>
            <HorizontalItem {...POSTS[1]} className={cx(styles.horizontal)} />
            <VerticalItem {...POSTS[3]} className={cx(styles.vertical)} />
          </div>
        </div>
      )}
    </section>
  );
};
export default View;
